import React, { useEffect } from 'react';
import range from 'lodash/range';
import RuleCard from './RuleCard';
import Input from 'shared/inputs/BaseInput';
import { REMOVE_TERM } from '../consts';
import useRulesContext from '../context';

const RemoveTerm = () => {
  const {
    term, ruleTypeId, onTermChange, onRuleTypeChange, dispatch,
  } = useRulesContext();

  const isActive = ruleTypeId === REMOVE_TERM;

  useEffect(() => {
    if (!isActive) {
      return;
    }
    dispatch('setValid', !!term && term.length > 0);
  }, [term]);

  const onClick = () => {
    dispatch('reset');
    onRuleTypeChange(REMOVE_TERM);
  };

  return (
    <RuleCard isActive={isActive} onClick={onClick}>
      Remove term
      {isActive && <Input autoFocus value={term} onChange={onTermChange} />}
      {!isActive && <span className='value-placeholder'>***</span>}
    </RuleCard>
  );
};

const RemoveTermPreview = () => {
  const { term } = useRulesContext();

  return (
    <>
      {range(0, 5).map((ind) => (
        <div key={`preview-char-${ind}`} className='preview-char included-char' />
      ))}
      {term.split('').map((char, ind) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`preview-char-${char}-${ind}`} className='preview-char'>
          {char}
        </div>
      ))}
      {range(0, 5).map((ind) => (
        <div key={`preview-char-${ind + 5}`} className='preview-char included-char' />
      ))}
    </>
  );
};

export default {
  RuleComponent: RemoveTerm,
  PreviewComponent: RemoveTermPreview,
  ruleTypesIds: [REMOVE_TERM],
};
